  const revealEls = document.querySelectorAll('.reveal');
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12 });
  revealEls.forEach(el => observer.observe(el));


  function toggleFAQ(btn) {
  const block = btn.closest('.faq_block');
  const content = block.querySelector('.block_content');
  const icon = btn.querySelector('.icon');
  const isOpen = block.classList.contains('is-open');

  document.querySelectorAll('.faq_block.is-open').forEach(openBlock => {
    openBlock.classList.remove('is-open');
    openBlock.querySelector('.block_content').style.maxHeight = null;
    openBlock.querySelector('.icon').textContent = '+';
  });

  if (!isOpen) {
    block.classList.add('is-open');
    content.style.maxHeight = content.scrollHeight + 'px';
    icon.textContent = '×';
  }
}